import React from 'react';

import { IJournalAttributesSchema } from '../../repositories/journal/entities/journal/JournalAttributesSchema';
import { ICommentParent } from '../../types/commentList';
import { sanitizePostContent } from '../../utils';

interface IPostCommentsMicrodata {
  postTitle: IJournalAttributesSchema['title'];
  postUrl: string;
  postContent: string;
  postAuthorName: string;
  postAuthorUrl: string;
  postLikeCount: number;
  postDatePublished: string;
  postComments: ICommentParent[];
  postImage: string;
}

/**
 * Микроразметка для комментариев DiscussionForumPosting
 * @see https://schema.org/DiscussionForumPosting
 */
export const PostCommentsMicrodata = ({
  postTitle,
  postUrl,
  postContent,
  postAuthorName,
  postAuthorUrl,
  postLikeCount,
  postDatePublished,
  postComments,
  postImage,
}: IPostCommentsMicrodata) => {
  const comments = postComments.map(({ comment, authorObject, likesCount, datePublish, comments }) => ({
    '@type': 'Comment',
    text: sanitizePostContent(comment),
    author: {
      '@type': 'Person',
      name:
        authorObject?.fullName ||
        authorObject?.companyName ||
        (authorObject?.userId ? `ID: ${authorObject.userId}` : 'Аноним'),
      url: authorObject?.specialistLink ? `https://www.cian.ru${authorObject.specialistLink}` : '',
    },
    datePublished: datePublish,
    interactionStatistic: {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/LikeAction',
      userInteractionCount: likesCount,
    },
    comment: comments?.length
      ? comments.map(({ comment, authorObject, likesCount, datePublish }) => ({
          '@type': 'Comment',
          text: sanitizePostContent(comment),
          author: {
            '@type': 'Person',
            name:
              authorObject?.fullName ||
              authorObject?.companyName ||
              (authorObject?.userId ? `ID: ${authorObject.userId}` : 'Аноним'),
            url: authorObject?.specialistLink ? `https://www.cian.ru${authorObject.specialistLink}` : '',
          },
          datePublished: datePublish,
          interactionStatistic: {
            '@type': 'InteractionCounter',
            interactionType: 'https://schema.org/LikeAction',
            userInteractionCount: likesCount,
          },
        }))
      : undefined,
  }));

  return (
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'DiscussionForumPosting',
        mainEntityOfPage: postUrl,
        headline: postTitle,
        text: postContent,
        image: postImage,
        url: postUrl,
        author: {
          '@type': 'Person',
          name: postAuthorName,
          url: postAuthorUrl,
        },
        datePublished: postDatePublished,
        interactionStatistic: {
          '@type': 'InteractionCounter',
          interactionType: 'https://schema.org/LikeAction',
          userInteractionCount: postLikeCount,
        },
        comment: comments,
      })}
    </script>
  );
};
